/*
 * Grouped product grid for standard collections (every collection except Sorrento,
 * which has its own grouping). Groups products by the FIRST 5 DIGITS of the item number
 * (SKU model), and renders one card per group with the other members as thumbnail options.
 *
 * Two cases decide which member is shown as the main product:
 *   - Group of 3+ members  -> main = the first member.
 *   - Group of exactly 2   -> ALTERNATE the main across successive 2-member groups
 *                             (1st -> member 1, 2nd -> member 2, 3rd -> member 1 ...),
 *                             for a tiled look.
 *   - Group of 1 (odd SKU) -> shown as a single card.
 *
 * Selecting a thumbnail swaps the main image + name and re-points the card's links;
 * clicking the main image / name / "View Product" opens the currently-selected product.
 *
 * Client-side because grouping needs the full product set. No jQuery dependency.
 */
(function () {
  'use strict';

  var grid = document.getElementById('collection-grouped-grid');
  if (!grid) return;

  var handle = grid.getAttribute('data-handle');
  var colClass = grid.getAttribute('data-col') || 'col-lg-4';
  var MODEL_RE = /^(\d{5})/; // first 5 digits of the SKU

  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : String(s)); return d.innerHTML; }
  function firstSku(p) { return (p.variants && p.variants[0] && p.variants[0].sku || '').trim(); }
  function imgOf(p) { return (p.images && p.images[0] && p.images[0].src) || ''; }
  function urlOf(p) { return '/products/' + p.handle; }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  // LAUNCH-2027 lock (live theme only): products created on/after 2026-11-01 00:00 Eastern are
  // unreleased and never reach the grid. Remove once the 2027 theme is published.
  var LAUNCH_CUTOFF = Date.parse('2026-11-01T00:00:00-04:00');
  function isReleased(p) { var t = Date.parse(p && p.created_at); return !(t >= LAUNCH_CUTOFF); }

  // Fetch every product (products.json caps at 250/page; the largest collection is ~863).
  function fetchAll(cb) {
    var all = [], page = 1;
    function next() {
      fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d && d.products) || [];
          all = all.concat(ps.filter(isReleased));
          if (ps.length === 250 && page < 10) { page++; next(); } else { cb(all); }
        })
        .catch(function () { cb(all); });
    }
    next();
  }

  // Group by first 5 digits of the SKU; preserve collection order for groups and members.
  function group(products) {
    var order = [], map = {};
    products.forEach(function (p) {
      var m = firstSku(p).match(MODEL_RE);
      var key = m ? m[1] : ('_' + p.handle); // no 5-digit model -> its own card
      if (!map[key]) { map[key] = { key: key, members: [] }; order.push(key); }
      map[key].members.push(p);
    });
    return order.map(function (k) { return map[k]; });
  }

  // Decide the default (main) member index per group, with the case-1 alternation.
  function assignMainIndex(groups) {
    var twoCount = 0;
    groups.forEach(function (g) {
      var n = g.members.length;
      if (n === 2) { g.mainIndex = twoCount % 2; twoCount++; } // alternate for 2-member groups
      else { g.mainIndex = 0; }                                 // 1 or 3+ -> first member
    });
    return groups;
  }

  function optionHtml(p, active) {
    return '<a href="' + esc(urlOf(p)) + '" class="cgroup-opt' + (active ? ' active' : '') + '"' +
      ' data-img="' + esc(imgOf(p)) + '" data-title="' + esc(p.title) + '" data-url="' + esc(urlOf(p)) + '"' +
      ' title="' + esc(p.title) + '"><img src="' + esc(imgOf(p)) + '" alt="' + esc(p.title) + '"></a>';
  }

  function cardHtml(g) {
    var members = g.members, mi = g.mainIndex || 0, def = members[mi];
    var opts = members.length > 1
      ? '<div class="cgroup-options">' + members.map(function (p, i) { return optionHtml(p, i === mi); }).join('') + '</div>'
      : '';
    return '<div class="js_size_prod col-md-6 ' + esc(colClass) + ' col-6 pb-4 trans-product cgroup-col">' +
      '<div class="product-item-v5 cgroup-card">' +
        '<div class="product engoj_grid_parent relative">' +
          '<div class="img-product relative">' +
            '<a href="' + esc(urlOf(def)) + '" class="engoj_find_img cgroup-main-link">' +
              '<img class="img-responsive cgroup-main-img" src="' + esc(imgOf(def)) + '" alt="' + esc(def.title) + '">' +
            '</a>' +
          '</div>' +
        '</div>' +
        '<h4 class="des-font capital title-product mb-0"><a href="' + esc(urlOf(def)) + '" class="cgroup-main-link cgroup-main-title">' + esc(def.title) + '</a></h4>' +
        opts +
        '<div class="pview"><a href="' + esc(urlOf(def)) + '" class="cgroup-main-link">View Product</a></div>' +
      '</div>' +
    '</div>';
  }

  function bind() {
    each(grid.querySelectorAll('.cgroup-col'), function (col) {
      var mainImg = col.querySelector('.cgroup-main-img');
      var title = col.querySelector('.cgroup-main-title');
      var links = col.querySelectorAll('.cgroup-main-link');
      each(col.querySelectorAll('.cgroup-opt'), function (opt) {
        opt.addEventListener('click', function (e) {
          e.preventDefault(); // thumbnail selects; main image / name / View Product navigate
          each(col.querySelectorAll('.cgroup-opt'), function (o) { o.classList.remove('active'); });
          opt.classList.add('active');
          var im = opt.getAttribute('data-img'),
              ti = opt.getAttribute('data-title'),
              u = opt.getAttribute('data-url');
          if (mainImg && im) { mainImg.src = im; mainImg.alt = ti; }
          if (title) { title.textContent = ti; }
          each(links, function (a) { a.setAttribute('href', u); });
        });
      });
    });
  }

  function render(groups) {
    if (!groups.length) {
      grid.innerHTML = '<div class="col-12 text-center" style="padding:40px 0;">No products found.</div>';
      return;
    }
    grid.innerHTML = groups.map(cardHtml).join('');
    bind();
  }

  fetchAll(function (products) { render(assignMainIndex(group(products))); });
})();
